import { manufacturingFetch } from "@/lib/manufacturingClient";

export type WasteWalkSession = {
  id: string;
  plant_id: string;
  status: "open" | "closed";
  caution_acknowledged_at: string;
  opened_at: string;
};

export type WasteWalkLine = {
  id: string;
  material_id: string;
  material_code: string;
  material_name: string;
  material_unit: string;
  qty_seen: number;
  qty_salvage: number;
  qty_scrap: number;
  unit_cost: number;
  marked_for_use: boolean;
  removed_from_area: boolean;
  scrap_posted_qty: number;
  salvage_posted_qty: number;
  created_at: string;
};

export type UnmarkedWasteLine = {
  material_id: string;
  material_code: string;
  material_name: string;
  created_at: string;
  qty_seen: number;
  qty_salvage: number;
  qty_scrap: number;
  marked_for_use: boolean;
  removed_from_area: boolean;
};

export type WasteWalkPayload = {
  ok: true;
  walk: WasteWalkSession | null;
  lines: WasteWalkLine[];
  unmarked: UnmarkedWasteLine[];
};

export type WasteTrajectory = {
  ok: true;
  window: "today" | "7d" | "month";
  since: string;
  in_waste_areas_usd: number;
  salvage_usd: number;
  scrap_usd: number;
  packed_write_off_usd: number;
};

export function getWasteWalk(plant_id: string) {
  return manufacturingFetch<WasteWalkPayload>("/api/mfg/waste-walk/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ plant_id }),
  });
}

export function openWasteWalk(plant_id: string) {
  return manufacturingFetch<WasteWalkPayload>("/api/mfg/waste-walk/open", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ plant_id, acknowledge_caution: true }),
  });
}

export function addWasteWalkLine(payload: {
  walk_id: string;
  material_id: string;
  qty_seen: number;
  qty_salvage: number;
  marked_for_use: boolean;
  removed_from_area: boolean;
}) {
  return manufacturingFetch<{ ok: true; line: WasteWalkLine }>("/api/mfg/waste-walk/lines", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function closeWasteWalk(walk_id: string) {
  return manufacturingFetch<{ ok: true; walk: WasteWalkSession }>("/api/mfg/waste-walk/close", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ walk_id }),
  });
}

export function getWasteTrajectory(plant_id: string, window: "today" | "7d" | "month") {
  return manufacturingFetch<WasteTrajectory>("/api/mfg/waste-walk/trajectory", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ plant_id, window }),
  });
}
